import { Container, StyledP } from './styles';

type Props = { count: number };

export const CountBadge = ({ count }: Props) => {
	const value = count > 99 ? ':D' : count;

	return (
		<Container>
			<StyledP size="XS">{value}</StyledP>
		</Container>
	);
};
